import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { InlineEmployee } from 'modules/employees/components/InlineEmployee'
import type { Expensable } from 'modules/expenses/components/expenses/DataTable/types'

export const Owner = ({ owner }: { owner: Expensable['owner'] }) => {
  if (owner) {
    return (
      <Box flexDirection="row" alignItems="center" gap="s16">
        <InlineEmployee employee={owner} variant="medium" linkProfile />
      </Box>
    )
  } else {
    return (
      <Box flexDirection="row" alignItems="center" gap="s16">
        <Avatar size="s40" label={i18n.t('banking.payments.unknown_person')} />
        <Text.Normal size="200">{i18n.t('banking.payments.unknown_person')}</Text.Normal>
      </Box>
    )
  }
}
